import React, { Component } from "react";
import dayjs from "dayjs";
import { MessageType } from "./Message";
import Retry from "./RetryMessage";
import { s360ConfigService } from "../../Services/S360Config";

class ImageMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: "",
      hovered: false,
    };
  }

  componentDidMount() {
    if (
      this?.props?.message?.message?.text !== null &&
      this?.props?.message?.message?.text
    ) {
      this.setState({ imgSrc: this?.props?.message?.message?.text });
    }
  }

  showImageInNewTab = () => {
    const { imgSrc } = this.state;

    let imageLink = imgSrc;
    if (!imageLink) {
      return;
    }
    window.open(imageLink, "_blank");
  };

  showMessageTime = () => {
    return this.props.message.type !== MessageType.info;
  };

  messageTimeClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-time-sent";
      case MessageType.received:
        return "s360-message-time-received";
      case MessageType.info:
        return "s360-message-time-info";
      default:
        return "";
    }
  };

  messageBoxClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return  "s360-message-box-sent";
      case MessageType.received:
        return  s360ConfigService.config.autoFullScreen?"s360-message-box-received-fs": "s360-message-box-received";
      case MessageType.info:
        return "s360-message-box-info";
      default:
        return "";
    }
  };

  messageContainerClassName = () => {
    switch (this.props.message.type) {
      case MessageType.sent:
        return "s360-message-cotainer-sent";
      case MessageType.received:
        return "s360-message-cotainer-received";
      case MessageType.info:
        return "s360-message-cotainer-info";
      default:
        return "";
    }
  };

  messageBoxStyle = () => {
    let config = this.props.config;
    switch (this.props.message.type) {
      case MessageType.sent:
        return {
          height: "105px",
          background: "#FFFFFF",
          fontFamily: config.designDetails.ReceiverMessageFont,
          fontSize: config.designDetails.ReceiverMessageFontSize,
          color: config.designDetails.recieverMessageFontColor,
        };
      case MessageType.received:
        return {
          height: "105px",
          background: "#FFFFFF",
          fontFamily: config.designDetails.SenderMessageFont,
          fontSize: config.designDetails.SenderMessageFontSize,
          color: config.designDetails.senderMessageFontColor,
        };
      default:
        return {};
    }
  };

  messageContainerStyle = () => {
    // let config = this.props.config

    return {};
  };

  messageTimeStyle = () => {
    let config = this.props.config;
    // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
    switch (this.props.message.type) {
      case MessageType.received:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      case MessageType.sent:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      case MessageType.info:
        return {
          fontFamily: config.designDetails.messageFont,
          fontSize: config.designDetails.messageTimeFontSize,
          color: config.designDetails.messageTimeFontColor,
        };
      default:
        return {};
    }
  };

  render() {
    const { imgSrc } = this.state;
    const imageBox = (
      <div
        className={this.messageBoxClassName()}
        style={this.messageBoxStyle()}
        onClick={this.showImageInNewTab}
      >
        {this.props.isOnlyEmoji ? (
          <div>{imgSrc}</div>
        ) : (
          <img
            style={{ objectFit: "contain", width: "100%" }}
            width="100%"
            height="100%"
            src={imgSrc}
            alt="Image attachment"
          />
        )}
      </div>
    );
    const footer = (
      <div style={{ display: "flex", alignItems: "center", marginRight: 7 }}>
        {this.showMessageTime() && (
          <div
            className={this.messageTimeClassName()}
            style={this.messageTimeStyle()}
          >
            {dayjs
              .unix(
                Math.trunc(
                  this?.props?.message?.message?.sentTimestamp / 1000
                )
              )
              .format("DD MMM h:mm a")}
          </div>
        )}

        <Retry {...this.props} />
      </div>
    );

    // Quote-reply is only wired when configDetails.enableQuoteReply is on; otherwise keep the original markup.
    const canReply = typeof this.props.onReplyToMessage === "function";
    if (!canReply) {
      return (
        <div
          className={this.messageContainerClassName()} /*style={this.messageContainerStyle()}*/
        >
          {imageBox}
          {footer}
        </div>
      );
    }

    const messageId = this.props.message?.message?.messageId;
    const sentTimestamp = this.props.message?.message?.sentTimestamp;
    const isSent = this.props.message.type === MessageType.sent;
    const showReply = this.state.hovered || (typeof window !== "undefined" && "ontouchstart" in window);

    return (
      <div
        className={this.messageContainerClassName()}
        data-s360-msg-id={messageId != null ? String(messageId) : undefined}
        data-s360-msg-ts={sentTimestamp != null ? String(sentTimestamp) : undefined}
        onMouseEnter={() => this.setState({ hovered: true })}
        onMouseLeave={() => this.setState({ hovered: false })}
      >
        <div
          style={{
            display: "flex", alignItems: "center", width: "100%", minWidth: 0,
            flexDirection: isSent ? "row-reverse" : "row",
          }}
        >
          {imageBox}
          <span
            role="button"
            aria-label="reply"
            title="Reply"
            aria-hidden={!showReply}
            onClick={(e) => { e.stopPropagation(); this.props.onReplyToMessage(this.props.message); }}
            style={{
              visibility: showReply ? "visible" : "hidden", margin: "0 4px",
              flexShrink: 0, cursor: "pointer", fontSize: 13, lineHeight: 1,
              color: "#005fec", background: "#fff", border: "1px solid #005fec",
              borderRadius: "50%", width: 24, height: 24,
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              boxShadow: "0 1px 3px rgba(0,0,0,0.15)",
            }}
          >
            ↩
          </span>
        </div>
        {footer}
      </div>
    );
  }
}

export default ImageMessage;
